import { render, staticRenderFns } from "./SPCategories.vue?vue&type=template&id=3bfb6b92&"
import script from "./SPCategories.vue?vue&type=script&lang=ts&"
export * from "./SPCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports